
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 480"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3f9c35","d":"M.1 0h640v480H.1z"}}),_c('path',{attrs:{"fill":"#ed2939","d":"M.1 0h640v320H.1z"}}),_c('path',{attrs:{"fill":"#00b9e4","d":"M.1 0h640v160H.1z"}}),_c('circle',{attrs:{"cx":"304","cy":"240","r":"72","fill":"#fff"}}),_c('circle',{attrs:{"cx":"320","cy":"240","r":"60","fill":"#ed2939"}}),_c('path',{attrs:{"fill":"#fff","d":"M384 200l7.7 21.5 20.6-9.8-9.8 20.7L424 240l-21.5 7.7 9.8 20.6-20.6-9.8L384 280l-7.7-21.5-20.6 9.8 9.8-20.6L344 240l21.5-7.7-9.8-20.6 20.6 9.8L384 200z"}})])
          )
        }
      }
    